<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择送货单"
      width="1200px"
      top="5vh">
    <view-table
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="soas/receiveDetail"
        @select="selectHandle">
      <template slot="otherBtn">
        <el-button type="primary" @click="selectRows">添加</el-button>
      </template>
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="采购订单">
            <el-input
                v-model.trim="filter.evaluate"
                type="textarea"
                autosize
                placeholder="请输入采购订单号"
                clearable/>
          </el-form-item>
          <el-form-item label="送货单号">
            <el-input
                v-model.trim="filter.asnNo"
                type="textarea"
                autosize
                placeholder="请输入送货单号"
                clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.partNo" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.partNameSpec" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="采购组">
            <el-input v-model.trim="filter.buyUserName" placeholder="请输入采购组" clearable/>
          </el-form-item>
          <el-form-item label="供应商编号">
            <el-input v-model.trim="filter.supplierNo" placeholder="请输入供应商编号" clearable/>
          </el-form-item>
          <el-form-item label="对账状态">
            <el-select v-model.trim="filter.soaStatus" placeholder="请选择对账状态">
              <el-option label="未对账" :value="'未对账'"/>
              <el-option label="部分对账" :value="'部分对账'"/>
              <el-option label="已对账" :value="'已对账'"/>
            </el-select>
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="createDateChange"
            />
          </el-form-item>
          <el-form-item label="到货日期">
            <el-date-picker
                v-model="arriveDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="arriveDateChange"
            />
          </el-form-item>
        </el-form>
      </template>
    </view-table>
  </el-dialog>
</template>

<script>
  import ViewTable from "@/components/ViewTable";

  export default {
    components: {ViewTable},
    data() {
      return {
        dialogVisible: false,
        filter: {
          evaluate: "",
          asnNo: "",
          partNo: "",
          partNameSpec: "",
          soaStatus: "未对账",
          straightMark: "",
          buyUserName: "",
          supplierNo: "",
          arriveDateEnd: "",
          arriveDateBegin: "",
          createDateBegin: "",
          createDateEnd: "",
        },
        arriveDate: "",
        createDate: "",
        columns: [
          {
            title: "合同类型",
            key: "clientContractTypeDesc",
            width: 120,
            align: "center",
          },
          {
            title: "合同编号",
            key: "clientContractNo",
            width: 300,
            align: "center",
          },
          {
            title: "客户名称",
            key: "customerName",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open(supplierNo) {
        if (supplierNo) {
          this.filter.supplierNo = supplierNo;
        }
        this.dialogVisible = true;
        // 清空查询条件
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },


      selectHandle(selection) {
        this.selection = selection;
      },

      selectRows() {
        this.dialogVisible = false;
        this.$emit("select", this.selection);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },

      arriveDateChange(value) {
        if (value) {
          this.filter.arriveDateBegin = value[0];
          this.filter.arriveDateEnd = value[1];
        } else {
          this.filter.arriveDateBegin = "";
          this.filter.arriveDateEnd = "";
        }
      },

      createDateChange(value) {
        if (value) {
          this.filter.createDateBegin = value[0];
          this.filter.createDateEnd = value[1];
        } else {
          this.filter.createDateBegin = "";
          this.filter.createDateEnd = "";
        }
      },
    },
  };
</script>
